module.exports = __webpack_public_path__ + "static/media/btg-azul.134c865e.webp";